import { ANALYTICS_DUE, DUE_SET } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case DUE_SET:
      return { ...state, due: action.payload };
    case ANALYTICS_DUE:
      return { ...state, due: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Due.js